import {registerTemplateGraphNode} from "#template/template-node/register"
import {pointGeometryAttributeSetLike, pointGeometryAttributeSetLikeMarker} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import type {PointGeometryAttributeSetLikeNode} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {MergeOperatorParameters} from "#template/nodes/geometry-graph/attribute-set/merge-operator/geometry-merge-operator-node"
import {
    GeometryMergeOperatorNode,
    mergeOperatorParametersSchema,
} from "#template/nodes/geometry-graph/attribute-set/merge-operator/geometry-merge-operator-node"

export type PointGeometryMergeOperatorParameters = MergeOperatorParameters<PointGeometryAttributeSetLikeNode>

const definition: TemplateNodeDefinition<PointGeometryMergeOperatorParameters> = {
    nodeClass: "PointGeometryMergeOperator",
    validation: {
        parameters: mergeOperatorParametersSchema(pointGeometryAttributeSetLike),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class PointGeometryMergeOperator extends GeometryMergeOperatorNode<0, PointGeometryAttributeSetLikeNode> implements PointGeometryAttributeSetLikeNode {
    get [pointGeometryAttributeSetLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
